"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const SearchBox_1 = __importDefault(require("components/SearchBox"));
const TreeNodeRow_1 = __importDefault(require("components/ResourceRegister/TreeNodeRow"));
const styles_1 = require("./styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.resourceRegisterStyles);
const ResourceRegister = ({ data, dataDictionary, onSave, onDelete, onRemoveNewItem, getCategoryByID, narrowMode = false, setDialog, onSelect, selectedItems, onSearchChange, resourceType, autoFocus = false, children, placeholder, noBorder = false, searchChildren = false, noHeader = false, }) => {
    const { classes } = useStyles();
    const [editingId, setEditingId] = (0, react_1.useState)(null);
    const [cancelEditingId, setCancelEditingId] = (0, react_1.useState)(null);
    const requestEditing = (id) => {
        setCancelEditingId(editingId !== id ? editingId : cancelEditingId);
        setEditingId(id);
    };
    const cleanEditingData = (id) => {
        setEditingId(id || null);
        setCancelEditingId(null);
    };
    const renderHeader = () => (<div className={classes.headerContainer}>
      {dataDictionary.map((row, index) => {
            const labelStyles = row.type === 'actions' ? { minWidth: 140 } : {};
            return (<Typography_1.default key={row.id} style={Object.assign(Object.assign({}, labelStyles), { flex: row.flex })} variant="subtitle2" className={(0, classnames_1.default)(classes.baseRowHead, {
                    [classes.firstRowHead]: index === 0,
                })}>
            {row.label}
          </Typography_1.default>);
        })}
    </div>);
    const renderRows = () => (<div className={classes.rowsContainer}>
      {children}
      {onSearchChange && (<SearchBox_1.default classes={{ smartSearch: noBorder ? classes.smartSearchNoBorder : classes.smartSearch }} onSearch={onSearchChange} autoFocus={autoFocus} placeholder={placeholder || `Search ${resourceType || 'items'}`} autoSearch/>)}
      {noBorder && <Divider_1.default />}
      {data.map((item, index) => (<TreeNodeRow_1.default key={item.id} narrowMode={narrowMode} item={item} rowIndex={[index]} dataDictionary={dataDictionary} onSave={onSave} onDelete={onDelete} onRemoveNewItem={onRemoveNewItem} getCategoryByID={getCategoryByID} setDialog={setDialog} onSelect={onSelect} selectedItems={selectedItems} expandForSearch={searchChildren} editingProps={{
                editingId,
                cancelEditingId,
                requestEditing,
                cleanEditingData,
            }}/>))}
    </div>);
    return (<div className={classes.rootContainer}>
      {!noHeader && renderHeader()}
      {renderRows()}
    </div>);
};
exports.default = ResourceRegister;
